<template>
  <div id="app">
    <div id="nav">
      <!--      <vue-particles-->
      <!--        color="#555"-->
      <!--        :particleOpacity="0.7"-->
      <!--        :particlesNumber="150"-->
      <!--        shapeType="circle"-->
      <!--        :particleSize="4"-->
      <!--        linesColor="#555"-->
      <!--        :linesWidth="1"-->
      <!--        :lineLinked="true"-->
      <!--        :lineOpacity="0.4"-->
      <!--        :linesDistance="150"-->
      <!--        :moveSpeed="2"-->
      <!--        :hoverEffect="true"-->
      <!--        hoverMode="grab"-->
      <!--        :clickEffect="false"-->
      <!--        clickMode="push"-->
      <!--        class="lizi"-->
      <!--      />-->
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    //  获取localStorage中存进去的theme-color
    // console.log(localStorage.getItem('theme-color'));
    /**
     *  判断 localStorage 中的 theme-color 是否为空，如果为空的话，就给默认的颜色（页面初始化的颜色），如
     *  果不为空的话就将对应获取到的值给到 data-theme
     **/
    if (localStorage.getItem("theme-color") != null) {
      window.document.documentElement.setAttribute(
        "data-theme",
        localStorage.getItem("theme-color")
      );
    } else {
      window.document.documentElement.setAttribute("data-theme", "blue");
    }
  },
};
</script>

<style lang="scss">
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
/*body{*/
/*  width: 100%;*/
/*  !*background-color: rgb(239, 239, 239);*!*/
/*}*/
/* .lizi{
    position:fixed;
    top:0;
    width:100%;
  } */
.span-ellipsis {
  width: 84%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  line-height: 1.1;
}
.el-menu--horizontal
  ul.el-menu.el-menu--popup.el-menu--popup-bottom-start
  li.el-menu-item {
  border-radius: 0px;
}
.el-menu--horizontal
  ul.el-menu.el-menu--popup.el-menu--popup-bottom-start
  li.el-submenu {
  border-radius: 0px !important;
}
.el-menu--horizontal
  ul.el-menu.el-menu--popup.el-menu--popup-bottom-start
  li.el-submenu
  .el-menu--horizontal
  ul.el-menu--popup-right-start
  li.el-menu-item {
  border-radius: 0px !important;
}
</style>
